
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1015_3756)","fill":"#FFB300"}},[_c('path',{attrs:{"d":"M32.338 4.155a2.14 2.14 0 00-.439 0H1.93a2.14 2.14 0 00-.567.086l15.467 15.402 15.51-15.488z"}}),_c('path',{attrs:{"d":"M33.922 5.643l-15.584 15.52a2.14 2.14 0 01-3.019 0L-.126 5.762a2.14 2.14 0 00-.075.535v21.408a2.14 2.14 0 002.14 2.14H31.91a2.14 2.14 0 002.14-2.14V6.296a2.14 2.14 0 00-.127-.653zM3.407 27.703H1.918v-1.53L9.7 18.456l1.51 1.509-7.804 7.739zm28.483 0H30.39l-7.803-7.738 1.51-1.51 7.781 7.718.01 1.53z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1015_3756"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h34v34H0z"}})])])])
          )
        }
      }
    